import React, { useContext, useMemo, PropsWithChildren, createContext, FC, useState } from "react";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { useGetAsyncStorage } from "../behaviors/useGetAsyncStorage";
import { Session, Store } from "../shared/types";

interface StaticInfo {
  readonly session: Session;
  readonly cdnPath: string;
  readonly basePath: string;
  readonly store: Store;
  readonly isPaymentOK: boolean;
  readonly tradename: Tradename;
  readonly apiUrl: () => string;
  readonly setIsPaymentOK: (isPaymentOK: boolean) => void;
}

const StaticInfoContext = createContext<StaticInfo>(undefined as unknown as StaticInfo);

interface StaticInfoProviderProps {
  readonly session: Session;
  readonly cdnPath: string;
  readonly basePath: string;
  readonly tradename: Tradename;
  readonly apiUrl: () => string;
}

const StaticInfoProvider: FC<PropsWithChildren<StaticInfoProviderProps>> = ({
  children,
  session,
  cdnPath,
  basePath,
  tradename,
  apiUrl,
}) => {
  const [isPaymentOK, setIsPaymentOK] = useState(false);

  const asyncStorage = useGetAsyncStorage();

  const value = useMemo(
    () => ({
      apiUrl,
      isPaymentOK,
      setIsPaymentOK,
      session,
      store: asyncStorage as Store,
      cdnPath,
      basePath,
      tradename,
    }),
    [apiUrl, isPaymentOK, session, asyncStorage, cdnPath, basePath, tradename],
  );

  return <StaticInfoContext.Provider value={value}>{asyncStorage ? children : null}</StaticInfoContext.Provider>;
};

const useStaticInfo = () => useContext(StaticInfoContext);

export { StaticInfoProvider, useStaticInfo };
